module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAclBMVEUAAAD/QFT/RFj/Qlb/wcf/Qlb/Qlb/Qlf/QFX/QFD/SUn/v8f/bHr/Qlb/////+vv/zNH/vsX/foz/YHH/5uj/w8n/g5D/bn7/8/X/lJ//Sl3/7/D/6uz/4uX/1dr/dYT/Rlr/3uH/zdP/oqz/oKr/jJjyNF+/AAAADXRSTlMAGT/oX9LEMiQQB19Hz+Hi9AAAALJJREFUOMu908kOwiAQgGFa7YI6Q5VqQbu5vf8r2lRCJnEgTQ9+Fw78p5mMWKRIxS71DtvZPi3cd5nBRiTgNfgFkJVzkEMogFxMJIQDkFOQxIIkEFTvLhbcB4DR3oLB1T1sQK0JnhXxYgLE/uz0qLigA69GLlD24ljFBmhqxyAbtKMfRssGptHOYLjgoYhqzaD0idBMYJDgtmmPhP0JGP8KZCyQ5HA4OT09RlYyx0sUYokP4e4ooqvIBM4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide/slide_6.png
// module id = idwS
// module chunks = 23